<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Nouveau prix engrais
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInput
        v-model="libelle"
        label="Nom *"
        hide-details
      />
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="prixEnEuroUnite"
        label="Coût *"
        suffix="€/unité"
        :rules="[rules.positif]"
        min="0"
      />
    </div>
    <div class="my-1 ml-5 action texte-gris-fonce">
      * Champs obligatoires
    </div>
    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        color="primary darken-1"
        :disabled="!isValid"
        @click="save()"
      >
        Valider
      </AgrButton>
    </v-card-actions>
    <v-snackbar
      v-if="erreur"
      v-model="erreur"
      class="top-snackbar"
      top
      right
      timeout="5000"
      color="red"
    >
      <v-icon
        color="white"
        class="mr-3"
      >
        mdi-alert-circle
      </v-icon>
      <span class="action white--text"> {{ erreur }} </span>
    </v-snackbar>
  </v-card>
</template>
<script>
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import AgrialInput from '@/components/form/agrial-input.vue'
import { mapActions } from 'vuex'

export default {
  name: 'NewParametrePrixModal',
  components: {AgrButton, AgrialInput, AgrialInputNumber},

  data () {
    return {
      libelle: null,
      prixEnEuroUnite: null,
      erreur: null,
      rules: {
        positif: value => (value != null && value >= 0) || 'Doit être >= 0',
      }
    }
  },

  computed: {
    isValid () { 
      return this.libelle != null && this.prixEnEuroUnite != null  && this.prixEnEuroUnite >= 0
    }
  },

  methods: {
    ...mapActions({
      createOrUpdateAdminComparateurMargeUnitesEngrais: 'comparateurMarge/createOrUpdateAdminComparateurMargeUnitesEngrais'
    }),
    
    onClose () {
      this.$emit('close')
    },
    save () {
      let uniteEngrais = {}
      uniteEngrais.libelle = this.libelle
      uniteEngrais.prixEnEuroUnite = this.prixEnEuroUnite
      this.createOrUpdateAdminComparateurMargeUnitesEngrais(uniteEngrais)
        .then(() => this.$emit('save'))
        .catch((error) => this.erreur = error.response.data.message)
    },
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>